import React, { FC, MouseEvent } from "react";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "../../store/hooks/selector.hook";
import Employees from "./Employees";
import { EmployeesColumns } from "./models/EmployeesColumns";
import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { getEmployeesListFetch, setPageEmployees } from "../../store/state/employees/employees.slice";
import { Filter } from "../../utl/models/Filters";
import usePagination from "../../utl/hooks/usePagination";
import culcPageTable from "../../utl/helpers/culcPageTable";

interface Props {
    data: EmployeesColumns[];
    handleClickRow: (item: any, event: MouseEvent<HTMLTableRowElement>) => void;
    vendorId: number;
}

const EmployeesPagination: FC<Props> = ({ vendorId, data, handleClickRow }) => {
    const dispatch = useAppDispatch();

    const page = useAppSelector(state => state.employees.page, shallowEqual);
    const totalCount = useAppSelector(state => state.employees.totalCount, shallowEqual);
    const pageAll = useAppSelector(state => state.employees.pageAll, shallowEqual);
    const pageSize = useAppSelector(state => state.employees.pageSize, shallowEqual);
    const getAllItems = useAppSelector(state => state.employees.getAllItems, shallowEqual);

    const setPage = (filter: Filter | undefined, pageNumber: number) => {
        dispatch(getEmployeesListFetch({ vendorId, filter }));
        dispatch(setPageEmployees({ page: pageNumber }));
    };

    const pagination = usePagination({
        getAllItems,
        pageAll,
        page,
        totalCount,
        pageSize,
        setPage,
        active: true,
    });

    const pagesRange = pagination.pagesRange;

    const pageTable = culcPageTable<EmployeesColumns>(data, pagesRange.from, pagesRange.to);

    return (
        <Employees
            data={pageTable}
            page={page}
            pages={pagination.pages}
            handleRightButtonPagination={pagination.handleRightButtonPagination}
            handleLeftButtonPagination={pagination.handleLeftButtonPagination}
            handleClickRow={handleClickRow}
        />
    );
}

export default React.memo(EmployeesPagination);